import { render, staticRenderFns } from "./ESGscoretimeline.vue?vue&type=template&id=a8e87656"
import script from "./ESGscoretimeline.vue?vue&type=script&lang=js"
export * from "./ESGscoretimeline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports